import React from 'react'
import styles from '../../layout.module.scss'
import { useNavigate } from 'react-router-dom'
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid'
import { useAuthStatus } from '../../../utils/auth'

export const LandingMenu = ({ userType, isLandingMenu }) => {
	const navigate = useNavigate()
	const [auth] = useAuthStatus()

	if (userType !== 'tourPro') {
		return (
			<div className={styles.landingMenu}>
				{/* <span
					className={styles.menuOption}
					onClick={() => {
						if (auth.isAuthentication) {
							navigate('/search')
						} else {
							navigate('/login')
						}
					}}>
					채용공고
				</span> */}
				<span
					className={styles.menuOption}
					onClick={() => {
						navigate('/training-program')
					}}>
					캐디 아카데미
				</span>
				<span className={styles.menuOption} onClick={() => navigate('/notice')}>
					공지사항
				</span>
				{/* {userType === 'tourCaddie' && (
					<button
						className={styles.btnBlack}
						onClick={() => {
							if (auth.isAuthentication) {
								navigate('/search')
							} else {
								navigate('/login', { state: { from: '/search' } })
							}
						}}>
						<MagnifyingGlassIcon
							style={{ width: '12px', height: '12px', color: 'white' }}
						/>
						<span>프로탐색</span>
					</button>
				)} */}
			</div>
		)
	} else if (userType === 'tourPro') {
		return (
			<div className={styles.landingMenu}>
				<span
					className={styles.menuOption}
					onClick={() => {
						if (auth.isAuthentication) {
							navigate('/training-program')
						} else {
							navigate('/login', { state: { from: '/training-program' } })
						}
					}}>
					캐디 아카데미
				</span>
				<span className={styles.menuOption} onClick={() => navigate('/notice')}>
					공지사항
				</span>
			</div>
		)
	} else {
		return null
	}
}
